import React, { FC, useContext } from "react"
import styled from "styled-components"

import { PricingTablePlanFragmentFragment } from "@graphqlTypes"

import Button, { BUTTON_VARIANTS } from "@components/Button/Button"

import ContentfulLpContext from "@context/ContentfulLpContext/ContentfulLpContext"

const PricingTableStickyHeaderDIV = styled.div`
  background: white;
  box-shadow: var(--elevation--S);
  opacity: 0;
  padding: var(--spacing--XS) 0;
  pointer-events: none;
  position: fixed;
  top: 0;
  transition: opacity 0.3s, translate 0.3s;
  translate: 0 -100%;
  width: 100%;
  z-index: 2;

  &.is-visible {
    opacity: 1;
    pointer-events: all;
    translate: 0 0;
  }

  .grid {
    align-items: flex-end;
  }

  h4 {
    margin: 0;
  }

  .flex {
    gap: 0;
  }

  .plan {
    flex: 0 0 33.3333%;
    padding: 0 var(--spacing--S);
    text-align: center;

    .Button {
      width: 100%;
    }
  }
`

const PricingTableStickyHeader: FC<{
  isVisible: boolean,
  plans?: Array<PricingTablePlanFragmentFragment | null> | null,
  title?: string,
}> = ({
  isVisible,
  plans,
  title,
}) => {
    if (!plans) return null

    const { isSalesPage } = useContext(ContentfulLpContext)

    return (
      <PricingTableStickyHeaderDIV className={isVisible ? "is-visible" : ""}>
        <div className="container">
          <div className="grid">
            <div className="column column--1-4-L column--1-5-XL">
              {title && <h4 className="type--headline-medium-L">{title}</h4>}
            </div>
            <div className="plans flex column column--4-13-L column--5-13-XL">
              {plans.map(plan => !plan ? null : (
                <div className="plan" key={plan.name}>
                  <h6 className="type--headline-medium-S">{plan.name}</h6>
                  {!isSalesPage && plan.ctaLink && plan.ctaText && (
                    <Button
                      href={plan.ctaLink}
                      variant={plan.id === "free" ? BUTTON_VARIANTS.SECONDARY : undefined}
                    >
                      {plan.ctaText}
                    </Button>
                  )}
                </div>
              ))}
            </div>
          </div>
        </div>
      </PricingTableStickyHeaderDIV>
    )
  }

export default PricingTableStickyHeader
